// Constantes extraites du proto Modules/12M Cash/treso_v9.jsx (lignes 13-146).
// VERBATIM — ne pas modifier la logique métier des taux cantonaux ni des presets.

export const MOIS = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
export const MOIS_COURT = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];
export const MOIS_LONG = ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];

// Délais en mois (0/1/2/3) — saisie simple sans M+
export const DELAIS = [0, 1, 2, 3];

// MODÈLES CANTONAUX (taux indicatifs 2026, à valider par canton/caisse)
export const MODELES_CANTONAUX = {
  BE: {
    label: 'BE',
    tauxCharges: [
      { code: 'avs_ai_apg',          libelle: 'AVS / AI / APG',                         employeur: 5.300, employe: 5.300, plafond: null },
      { code: 'ac',                   libelle: 'AC',                                      employeur: 1.100, employe: 1.100, plafond: 148200 },
      { code: 'allocations_familiales', libelle: 'Allocations familiales & participation', employeur: 1.600, employe: 0,     plafond: null },
      { code: 'frais_admin',          libelle: 'Frais admin',                             employeur: 0.200, employe: 0,     plafond: null },
    ],
    laa: 0.80, aanp: 1.40, ijm: 1.20,
  },
  FR: {
    label: 'FR',
    tauxCharges: [
      { code: 'avs_ai_apg',          libelle: 'AVS / AI / APG',                         employeur: 5.300, employe: 5.300, plafond: null },
      { code: 'ac',                   libelle: 'AC',                                      employeur: 1.100, employe: 1.100, plafond: 148200 },
      { code: 'allocations_familiales', libelle: 'Allocations familiales cantonales CAF', employeur: 2.270, employe: 0,     plafond: null },
      { code: 'fonds_formation',      libelle: 'Formation professionnelle LFP',           employeur: 0.040, employe: 0,     plafond: null },
      { code: 'accueil_jour',         libelle: 'Fonds accueil de jour LStE',              employeur: 0.040, employe: 0,     plafond: null },
      { code: 'frais_admin',          libelle: 'Frais administratifs AVS/CAF',            employeur: 0.250, employe: 0,     plafond: null },
    ],
    laa: 2.350, aanp: 1.40, ijm: 1.20,
  },
  GE: {
    label: 'GE',
    tauxCharges: [
      { code: 'avs_ai_apg',          libelle: 'AVS / AI / APG',                         employeur: 5.300, employe: 5.300, plafond: null },
      { code: 'ac',                   libelle: 'AC',                                      employeur: 1.100, employe: 1.100, plafond: 148200 },
      { code: 'allocations_familiales', libelle: 'Allocations familiales & participation', employeur: 2.220, employe: 0,     plafond: null },
      { code: 'petite_enfance',       libelle: 'Petite enfance',                          employeur: 0.070, employe: 0,     plafond: null },
      { code: 'fonds_formation',      libelle: 'Formation professionnelle (LFAAP)',       employeur: 0.082, employe: 0,     plafond: null },
      { code: 'maternite',            libelle: 'Assurance maternité AMat',                employeur: 0.029, employe: 0.029, plafond: 148200 },
      { code: 'frais_admin',          libelle: 'Frais admin',                             employeur: 0.300, employe: 0,     plafond: null },
    ],
    laa: 0.85, aanp: 1.50, ijm: 1.20,
  },
  JU: {
    label: 'JU',
    tauxCharges: [
      { code: 'avs_ai_apg',          libelle: 'AVS / AI / APG',                         employeur: 5.300, employe: 5.300, plafond: null },
      { code: 'ac',                   libelle: 'AC',                                      employeur: 1.100, employe: 1.100, plafond: 148200 },
      { code: 'allocations_familiales', libelle: 'Allocations familiales & participation', employeur: 2.450, employe: 0,     plafond: null },
      { code: 'frais_admin',          libelle: 'Frais admin',                             employeur: 0.300, employe: 0,     plafond: null },
    ],
    laa: 0.85, aanp: 1.45, ijm: 1.20,
  },
  NE: {
    label: 'NE',
    tauxCharges: [
      { code: 'avs_ai_apg',          libelle: 'AVS / AI / APG',                         employeur: 5.300, employe: 5.300, plafond: null },
      { code: 'ac',                   libelle: 'AC',                                      employeur: 1.100, employe: 1.100, plafond: 148200 },
      { code: 'allocations_familiales', libelle: 'Allocations familiales cantonales',     employeur: 1.800, employe: 0,     plafond: null },
      { code: 'fonds_formation',      libelle: 'LFAPP',                                   employeur: 0.507, employe: 0,     plafond: null },
      { code: 'frais_admin',          libelle: 'Frais admin',                             employeur: 0.300, employe: 0,     plafond: null },
    ],
    laa: 0.82, aanp: 1.45, ijm: 1.20,
  },
  VD: {
    label: 'VD',
    tauxCharges: [
      { code: 'avs_ai_apg',          libelle: 'AVS / AI / APG',                         employeur: 5.300, employe: 5.300, plafond: null },
      { code: 'ac',                   libelle: 'AC',                                      employeur: 1.100, employe: 1.100, plafond: 148200 },
      { code: 'allocations_familiales', libelle: 'Allocations familiales / fonds inclus', employeur: 2.750, employe: 0,     plafond: null },
      { code: 'pc_famille',           libelle: 'PC Famille / Rente-Pont',                employeur: 0.090, employe: 0.090, plafond: null },
      { code: 'frais_admin',          libelle: 'Frais admin',                             employeur: 0.300, employe: 0,     plafond: null },
    ],
    laa: 0.79, aanp: 1.39, ijm: 1.20,
  },
  VS: {
    label: 'VS',
    tauxCharges: [
      { code: 'avs_ai_apg',          libelle: 'AVS / AI / APG',                         employeur: 5.300, employe: 5.300, plafond: null },
      { code: 'ac',                   libelle: 'AC',                                      employeur: 1.100, employe: 1.100, plafond: 148200 },
      { code: 'allocations_familiales', libelle: 'Allocations familiales / fonds CIVAF',  employeur: 2.780, employe: 0.131, plafond: null },
      { code: 'frais_admin',          libelle: 'Frais admin',                             employeur: 0,     employe: 0,     plafond: null },
    ],
    laa: 0.82, aanp: 1.45, ijm: 1.20,
  },
};

export const PRESETS_DEFAUT = {
  flat:      { label: 'Constant',      desc: 'Aucune',            calendarBased: false, factors: Array(12).fill(1) },
  ete_creux: { label: 'Creux estival', desc: 'Pause juil-août',   calendarBased: true,  factors: [1.05, 1.05, 1.10, 1.10, 1.05, 0.90, 0.70, 0.70, 1.05, 1.15, 1.15, 1.00] },
  q4_pic:    { label: 'Pic Q4',        desc: 'Forte fin année',   calendarBased: true,  factors: [0.85, 0.90, 0.95, 0.95, 0.95, 0.95, 0.85, 0.85, 1.05, 1.15, 1.25, 1.30] },
  ramp:      { label: 'Ramp-up',       desc: 'Croissance prog.',  calendarBased: false, factors: [0.60, 0.70, 0.80, 0.85, 0.90, 0.95, 1.00, 1.05, 1.10, 1.20, 1.35, 1.50] },
};

export const SUGGESTIONS_MENSUEL = [
  'Loyers',
  'Charges accessoires des locaux commerciaux',
  'Nettoyage, entretien des locaux',
  'Assurances-choses',
  'Droits, taxes autorisations et patentes',
  'Matériel de bureau',
  'Téléphone + internet',
  'Licences informatiques',
  'Frais de port',
  'Cotisations, dons, cadeaux',
  'Honoraires pour fiduciaire',
  'Honoraires juridiques / conseil',
  'Services administratifs, comptables et autres',
  'Publicité',
  'Frais de voyage, conseils à la clientèle',
  'Frais de représentation',
];

export const SUGGESTIONS_SPECIFIQUE = [
  'Honoraires fiduciaire',
  'Honoraires juridiques',
  'Honoraires conseil externe',
  'Marketing & publicité',
  'Frais de représentation',
  'Formation collaborateurs',
  'Voyages & déplacements',
  'Cotisations associations professionnelles',
  'Maintenance technique annuelle',
  'Audit / contrôle externe',
  'Assurance RC',
  'Assurance juridique',
  'Autres assurances',
];
